import { AxiosInstance } from "axios";
import axiosBase from "./base";
import { store } from "store/store";

class CivicDialogueService {
  base: AxiosInstance;

  constructor() {
    this.base = axiosBase.base;
  }

  getVolunteerDocuments(id: number): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const state = store.getState();
      const language = state.language.language;

      this.base
        .get(`documents/${id}?populate=*&locale=${language}`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getVoluntaryInfo(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const state = store.getState();
      const language = state.language.language;

      this.base
        .get(`voluntary?populate=*&locale=${language}`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
}
const civicDialogueService = new CivicDialogueService();
export default civicDialogueService;
